<template>
  <el-select
    v-model="idSocketGroupLocal"
    filterable
    clearable
    :placeholder="$t('t_socket_group_list_name_placeholder')"
    :no-match-text="$t('t-match-data')"
    :no-data-text="$t('t-no-data')"
    @change="onSelectSocketGroup"
  >
    <el-option
      v-for="item in listSocketGroup"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script setup>
import { ref, onMounted, watch, defineProps, defineEmits } from "vue";
import mushroom from "cem-primary-api";
const props = defineProps({
  modelValue: { type: String, default: null },
});
const emit = defineEmits(["update:modelValue", "change"]);
const listSocketGroup = ref([]);
const idSocketGroupLocal = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    idSocketGroupLocal.value = newVal;
  }
);

const fetchDataSocketGroup = async () => {
  const resSocketGroup = await mushroom.api_socket_group.getAllAsync();
  const groups = resSocketGroup.result || [];

  if (groups.length === 0) {
    listSocketGroup.value = [];
    return;
  }

  const filteredGroups = groups.filter((g) => g.socket_ids?.length > 0);

  listSocketGroup.value = filteredGroups.map((group) => ({
    value: group.id,
    label: group.name,
  }));
};

const onSelectSocketGroup = (value) => {
  emit("update:modelValue", value);
};

onMounted(async () => {
  await fetchDataSocketGroup();
});
</script>
